import {
  dealTypeFromJsonQuery,
  FDealType,
  FOfferType,
  offerTypeFromJsonQuery,
  type TJsonQuery,
} from '../../../packages/JsonQuery';

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export function getIsFlatSale(jsonQuery: TJsonQuery) {
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const dealType = dealTypeFromJsonQuery(jsonQuery);

  // Только вторичка продажа квартир
  const isFlatSale = offerType === FOfferType.FlatOld && dealType === FDealType.Sale;

  return isFlatSale;
}
